import { INITIALIZE_SOCKET,WITHOUT_INIT_SOCKET,GET_SOCKET_CONNECTION_STATUS, SET_CREW_MATTERS_CONVERSATION_ID } from "../constants";

const initialState = {
    initializeSocket: false,
    withoutInitSocket:false,
    socketConnectionStatus: false,
    crewMattersConversationId: null
};

const socketReducer = (state = initialState, action = null) => {
    switch (action.type) {
        case INITIALIZE_SOCKET:
            return {
                ...state,
                initializeSocket: action.payload,
            };
            case GET_SOCKET_CONNECTION_STATUS:
            return {
                ...state,
                socketConnectionStatus: action.payload,
            }
            case WITHOUT_INIT_SOCKET:
            return {
                ...state,
                withoutInitSocket: action.payload,
            };
            case SET_CREW_MATTERS_CONVERSATION_ID:
            return {
                ...state,
                crewMattersConversationId: action.payload,
            };
        default:
            return state;
    }
};

export default socketReducer;
